import React, { Component } from "react";
import ReactTable from "react-table-6";
import "react-table-6/react-table.css";
import MenuBar from "./navbar";
import SocialMediaLinks from "./socialmedialinks";
import Header from "./header";
import { BASE_URL } from "./utility";
import { Redirect } from "react-router-dom";

class InvoiceReport extends Component {
  constructor() {
    super();
    this.state = {
      type: "",
      selectedState: "",
      items: [],
      redirectToLogin: false,
    };
  }

  // 🔐 Helper: Fetch wrapper that auto-handles 401 and JSON parsing
  safeFetch = async (url, options = {}) => {
    try {
      const res = await fetch(url, {
        ...options,
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("token"),
          ...options.headers,
        },
      });

      if (res.status === 401) {
        localStorage.removeItem("token");
        this.setState({ redirectToLogin: true });
        return null;
      }

      return res;
    } catch (err) {
      console.error("Fetch Error:", err);
      return null;
    }
  };

  // Unified dropdown handler
  handleDropdownUpdate = (field, value) => {
    this.setState({ [field]: value }, async () => {
      const { selectedState, type } = this.state;

      if (selectedState && type) {
        const res = await this.safeFetch(
          `${BASE_URL}/getInvoiceDetails/${type}/${selectedState}`,
          { method: "GET" }
        );

        if (!res) return; // already redirected

        const responseJson = await res.json();

        const result = responseJson.map((item) => {
          const data = JSON.parse(item.data);
          return {
            refnum: item.refnum,
            gstType: item.gstType,
            date: data.orderDate ? data.orderDate.split(" ")[0] : data.date.split(" ")[0],
            data: item.data,
          };
        });

        this.setState({ items: result });
      }
    });
  };

  // Download invoice
  handleDownload = async (e) => {
    const value = e.target.value;

    const res = await this.safeFetch(`${BASE_URL}downloadInvoice`, {
      method: "POST",
      body: value,
    });

    if (!res) return;

    const blob = await res.blob();
    const file = window.URL.createObjectURL(blob);
    window.location.assign(file);
  };

  // Delete invoice
  handleDelete = async (e) => {
    const value = e.target.value;
    e.preventDefault();

    if (!window.confirm(`Are you sure you want to delete invoice: ${value}?`)) {
      return;
    }

    const url = `${BASE_URL}deleteInvoice/${this.state.type}/${this.state.selectedState}/${value}`;

    const res = await this.safeFetch(url, { method: "DELETE" });
    if (!res) return;

    alert("Invoice deleted successfully!");
    window.location.reload();
  };

  render() {
    // 🔐 Redirect if token expired
    if (this.state.redirectToLogin) return <Redirect to="/auth" />;

    // 🔐 Redirect if token missing
    if (!localStorage.getItem("token")) return <Redirect to="/auth" />;

    const { items } = this.state;

    const columns = [
      {
        Header: "Invoice No.",
        accessor: "refnum",
        minWidth: 120,
      },
      {
        Header: "Tax Type",
        accessor: "gstType",
        minWidth: 100,
      },
      {
        Header: "Date",
        accessor: "date",
        minWidth: 130,
      },
      {
        Header: "Action",
        accessor: "data",
        minWidth: 180,
        Cell: ({ row }) => (
          <div
            style={{ display: "flex", justifyContent: "center", gap: "10px" }}
          >
            <button
              value={row.data}
              onClick={this.handleDownload}
              className="btn-download"
            >
              Download
            </button>
            <button
              value={row.refnum}
              onClick={this.handleDelete}
              className="btn-delete"
            >
              Delete
            </button>
          </div>
        ),
      },
    ];

    return (
      <div
        className="invoice-report"
        style={{
          backgroundImage: `url(${BASE_URL + "download/general/bg"})`,
          minHeight: "100vh",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <Header />
        <center>
          <MenuBar />
          <h2 style={{ color: "white", marginTop: "20px" }}>Invoice Reports</h2>

          <div style={{ marginTop: "20px" }}>
            <select
              style={styles.dropdown}
              onChange={(e) =>
                this.handleDropdownUpdate("selectedState", e.target.value)
              }
            >
              <option value="">Select State</option>
              <option value="delhi">Delhi</option>
              <option value="odisha">Odisha</option>
            </select>

            <select
              style={styles.dropdown}
              onChange={(e) =>
                this.handleDropdownUpdate("type", e.target.value)
              }
            >
              <option value="">Select Report Type</option>
              <option value="tax">Tax Invoice</option>
              <option value="pro">Pro forma Invoice</option>
              <option value="credit">Credit Note</option>
              <option value="challan">Delivery Challans</option>
              
            </select>
          </div>

          {items.length > 0 && (
            <div style={styles.tableWrapper}>
              <ReactTable
                className="-striped -highlight"
                data={items}
                columns={columns}
                defaultPageSize={10}
                resizable={false}
                style={styles.table}
              />
              <div style={styles.recordCount}>
                Total Records: {items.length}
              </div>
            </div>
          )}
        </center>

        <div style={{ marginTop: "30px" }}>
          <SocialMediaLinks />
        </div>
      </div>
    );
  }
}

// 🎨 Styles
const styles = {
  dropdown: {
    padding: "8px 12px",
    margin: "10px",
    borderRadius: "6px",
    border: "1px solid #ccc",
    fontSize: "14px",
  },
  tableWrapper: {
    marginTop: "30px",
    width: "90%",
    maxWidth: "900px",
    borderRadius: "12px",
    backgroundColor: "white",
    boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
    overflow: "hidden",
  },
  table: {
    border: "none",
    borderRadius: "10px",
    width: "100%",
  },
};

// 💅 Button Styles
const styleSheet = document.createElement("style");
styleSheet.innerHTML = `
  .btn-download, .btn-delete {
    border: none;
    border-radius: 6px;
    padding: 6px 10px;
    cursor: pointer;
    color: white;
    font-weight: 500;
  }
  .btn-download {
    background-color: #3b82f6;
  }
  .btn-download:hover {
    background-color: #2563eb;
  }
  .btn-delete {
    background-color: #ef4444;
  }
  .btn-delete:hover {
    background-color: #dc2626;
  }
`;
document.head.appendChild(styleSheet);

export default InvoiceReport;
